import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {Button, Col, Container, Row} from 'react-bootstrap';
import UserDetailsForm from './user-details-form';
import BackLink from '../../../common/back-link/index';
import PageTitle from '../../../common/page-title/index';
import { doPseudoLogin, getUserDetails } from '../../../../actions/users';
import { GROUP_ABM, GROUP_RBM, GROUP_RDR } from '../../../../data/userGroups';
import Can from '../../../common/guards/can';

import './styles.css';

class EditUser extends Component {
  isRep = userGroup => !![GROUP_ABM, GROUP_RBM, GROUP_RDR].find(group => group === userGroup.toLowerCase());

  state = {};

  onPseudoLogin = () => {
    doPseudoLogin(this.id);
  };

  setPermission = () => {
    const { user } = this.props;
    // eslint-disable-next-line no-prototype-builtins
    if (user.attributes.hasOwnProperty('user-group-name')) {
      return this.isRep(user.attributes['user-group-name']) ?
        'rep-pseudo-login-read,rep-pseudo-login-write' :
        'pseudo-login-read,pseudo-login-write';
    }
    return '';
  };

  isImpersonable = () => {
    const {attributes} = this.props.user;

    return !!attributes
      && !['disabled', 'pending', 'invited', 'expired'].includes(attributes.status)
      && !attributes['account-locked'];
  };

  UNSAFE_componentWillMount() {
    this.id = +this.props.match.params.id;
    this.props.dispatch(getUserDetails(this.id));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_user.details'));
    this.props.dispatch({type: 'CLEAR_EDIT_USER'});
  }

  render() {
    const {user} = this.props;

    const permission = this.setPermission();

    return (
      <Container fluid className="users">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/users"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="header">
              <PageTitle className="float-start">
                Add/Edit user
              </PageTitle>
              {this.isImpersonable() && (
                <Can action={permission} subjectClass="web_app">
                  <Button
                    className="red-ghost-btn pseudo-login"
                    onClick={() => this.onPseudoLogin(user)}
                  >
                    Pseudo log in
                  </Button>
                </Can>
              )}
            </div>
          </Col>
        </Row>
        {user.relationships && (
          <UserDetailsForm edit={!!this.id} user={user}/>
        )}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  user: state.users.user,
  fetched: state.users.fetched,
  fetching: state.users.fetching,
});

export default connect(mapStateToProps)(EditUser);
